import { render } from "./department-modal.vue?vue&type=template&id=3db7727a"
import script from "./department-modal.vue?vue&type=script&lang=js"
export * from "./department-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__